import { format } from "rut.js";

export const removeDots = (string = "") => string.replace(/\./g, "");

export const formatRut = (rutString = "") => format(rutString);
